import TextField from '@mui/material/TextField';
import React from 'react';

type EnhancedTableFilterProps = {
  filters: {
    id: string;
    label: string;
  }[];
  onChange: (id: string, event: any) => void;
  disabled: boolean;
  filterValues: { [key: string]: string };
};

/**
    @param  filters   table headers that should be treated as filterable columns
    @param  onChange  function that takes in the filter id and the event for the text on change
*/
function EnhancedTableFilter({
  filters,
  onChange,
  disabled,
  filterValues,
}: EnhancedTableFilterProps) {
  /**
    https://material-ui.com/components/text-fields/#textfield
      standard, filled, outlined
  */
  const variant = 'outlined';
  const filterStyle = {
    paddingLeft: '25px',
    padding: '12px 25px',
    width: `${100 / filters.length}%`,
  };

  return (
    <div className="table-filter">
      {filters.length > 0 &&
        filters.map((filter, index) => (
          <div style={filterStyle} key={`filter-column-${index}`}>
            <TextField
              disabled={disabled}
              variant={variant}
              label={filter.label}
              onChange={evt => onChange(filter.id, evt)}
              value={
                filterValues
                  ? filterValues[filter.id] === undefined
                    ? ''
                    : filterValues[filter.id]
                  : ''
              }
            />
          </div>
        ))}
    </div>
  );
}

export default EnhancedTableFilter;
